import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { noop } from 'lodash-es';

import './delivery-button.scss';

export function DeliveryButton({
  url = '',
  dataTest = '',
  isMobile = false,
  onClick = noop,
  dataTrackingValue = '',
  dataTrackingId = '',
  parentTracking = '',
  ctaTitle = 'Get It Delivered',
  ctaClasses = 'btn-lg',
}) {
  return (
    <div data-tracking-parent={parentTracking}>
      <a
        href={url}
        target="_blank"
        style={{ marginTop: '1rem' }}
        rel="noopener noreferrer"
        className={classNames(
          'btn btn-blue-50 text-capitalize text-white delivery-btn mt-md-1 px-2 size-20 mt-1_5',
          ctaClasses
        )}
        onClick={onClick}
        data-test={dataTest}
        data-tracking-value={dataTrackingValue}
        data-tracking-id={dataTrackingId}
      >
        <span className={classNames({ 'align-self-center': isMobile })}>
          {ctaTitle}
          <i className="icon-open_in_new medium ms-0_25" aria-hidden />
        </span>
      </a>
    </div>
  );
}

DeliveryButton.propTypes = {
  url: PropTypes.string,
  dataTest: PropTypes.string,
  isMobile: PropTypes.bool,
  onClick: PropTypes.func,
  dataTrackingValue: PropTypes.string,
  dataTrackingId: PropTypes.string,
  parentTracking: PropTypes.string,
  ctaTitle: PropTypes.string,
  ctaClasses: PropTypes.string,
};
